import { works } from '@/mocks/articles';

export default function FeaturedWorks() {
  const featuredWorks = works.filter((w) => w.featured);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            代表作品
          </h2>
          <p className="text-sm text-foreground-500">音乐、影视、出版 —— 多元领域的精彩绽放</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredWorks.map((work) => (
            <div
              key={work.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={work.image}
                  alt={work.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500/90 text-background-50 whitespace-nowrap">
                    {work.type}
                  </span>
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/80 text-foreground-700 whitespace-nowrap">
                    {work.year}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">{work.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{work.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}